import { render } from "./DeveloperStyle.vue?vue&type=template&id=43c65ba0"
import script from "./DeveloperStyle.vue?vue&type=script&lang=js"
export * from "./DeveloperStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__